/* CAMPAIGN FORMAT DATA */
export const GET_CAMPAIGN_FORMATS_LIST = "GET_CAMPAIGN_FORMATS_LIST"
export const SET_CAMPAIGN_FORMATS_LIST = "SET_CAMPAIGN_FORMATS_LIST"
export const ADD_CAMPAIGN_FORMAT = "ADD_CAMPAIGN_FORMAT"

/* CAMPAIGNS FORMAT ACTIONS */
export const DELETE_CAMPAIGN_FORMAT = "DELETE_CAMPAIGN_FORMAT";

/* CAMPAIGN FORMAT DATA */
export const GET_CAMPAIGN_FORMAT_PROFILE = "GET_CAMPAIGN_FORMAT_PROFILE"
export const SET_CAMPAIGN_FORMAT_PROFILE = "SET_CAMPAIGN_FORMAT_PROFILE"
export const UPDATE_CAMPAIGN_FORMAT_PROFILE = "UPDATE_CAMPAIGN_FORMAT_PROFILE"
export const SET_ERROR_CAMPAIGN_FORMAT_PROFILE = "SET_ERROR_CAMPAIGN_FORMAT_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_FORMATS_LIST_LOADER = "SHOW_CAMPAIGN_FORMATS_LIST_LOADER"
export const HIDE_CAMPAIGN_FORMATS_LIST_LOADER = "HIDE_CAMPAIGN_FORMATS_LIST_LOADER"
